import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseSummaryControlDirective } from '../base/base-summary-control';
import { VraagboomMultiResultaat } from '@models/vragenboom';

@Component({
  selector: 'app-tekstregel-summary',
  templateUrl: './tekstregel-summary.component.html',
  styleUrls: ['./tekstregel-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TekstregelSummaryComponent extends BaseSummaryControlDirective<VraagboomMultiResultaat> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }

  geefAntwoord(): string {
    if (this.antwoordResultaat && this.antwoordResultaat.antwoorden) {
      if (this.antwoordResultaat.antwoorden[0].waarde?.length === 0) {
        if (this.antwoordResultaat.vraag && !this.antwoordResultaat.vraag.verplicht) {
          if (this.antwoordResultaat.vraag.antwoorden?.length > 0
            && this.antwoordResultaat.vraag.antwoorden[0].standaard_waarde) {
            return this.antwoordResultaat.vraag.antwoorden[0].standaard_waarde;
          } else {
            return 'Nee';
          }
        }
      } else {
        return this.antwoordResultaat.antwoorden[0].waarde;
      }
    }
    return '';
  }
}
